export default __webpack_public_path__ + "static/team_ben-58b95713e2245ec53885bf035c1beb90.png";